<template>
  <div class="central_content">
    <div class="search_list">
      <div class="text">群组:</div>
      <Select
        v-model="parameter.groupId"
        class="select"
        @on-change="
          parameter.pageNow = 1;
          getData();
        "
      >
        <Option
          v-for="(data, index) in queryList"
          :key="index"
          :value="data.id"
          >{{ data.name }}</Option
        >
      </Select>
      <Button
        @click="
          upData = {};
          title = '添加';
          Show = true;
        "
        style="margin-left: 15px"
        type="primary"
        >添加</Button
      >
    </div>

    <Table
      border
      class="table_style"
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="config">
        <Button
          @click="
            upData = row;
            title = '编辑';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >编辑</Button
        >
        <Button
          @click="
            upData = row;
            title = '删除';
            Show = true;
          "
          style="margin-right: 15px"
          type="primary"
          >删除</Button
        >
      </template>
    </Table>
    <Modal width="500" v-model="Show" :title="title" @on-ok="UaorderShip">
      <div v-if="title == '删除'">删除</div>
      <div v-else>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>名称:</div>
          <div>
            <Input
              v-model="upData.name"
              placeholder="名称"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>佣金:</div>
          <div>
            <Input
              v-model="upData.commission"
              placeholder="佣金"
              style="width: 300px"
            />
          </div>
        </div>
        <div style="display: flex; align-items: center; margin-top: 15px">
          <div>群组id:</div>
          <div>
            <Select
              v-model="upData.groupId"
              class="select"
              @on-change="
                parameter.pageNow = 1;
                getData();
              "
            >
              <Option
                v-for="(data, index) in queryList"
                :key="index"
                :value="data.id"
                >{{ data.name }}</Option
              >
            </Select>
          </div>
        </div>
      </div>
    </Modal>
    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      queryList: [],
      userList: { list: [] },
      title: "",
      upData: {},
      Show: false,
      parameter: {
        pageNow: 1,
      },
      columns: [
        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
        },
        {
          title: "名称",
          className: "fontcolor",
          align: "center",
          key: "name",
        },
        {
          title: "佣金",
          align: "center",
          className: "fontcolor",
          key: "commission",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createTime",
          className: "fontcolor",
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime",
          className: "fontcolor",
        },

        {
          title: "操作",
          className: "fontcolor",
          align: "center",
          slot: "config",
          fixed: "right",
        },
      ],
    };
  },
  mounted: function () {
    api
      .OutsideGroupQueryList({
        pageNow: 1,
        pageSize: 99999,
      })
      .then((res) => {
        this.queryList = res.body.data.list;
      });
    this.getData();
  },
  methods: {
    UaorderShip() {
      if (this.title == "添加") {
        api
          .OutsideProductAdd({
            name: this.upData.name,
            groupId: this.upData.groupId,
            commission: this.upData.commission * 100,
          })
          .then((res) => {
            if (res.body.status) {
              this.$Message.info(res.body.message);
            }
            this.getData();
          });
      }
      if (this.title == "编辑") {
        api
          .OutsideProductEdit({
            id: this.upData.id,
            name: this.upData.name,
            groupId: this.upData.groupId,
            commission: this.upData.commission * 100,
          })
          .then((res) => {
            if (res.body.status) {
              this.$Message.info(res.body.message);
            }
            this.getData();
          });
      }
      if (this.title == "删除") {
        api.OutsideProductDel(this.upData.id).then((res) => {
          if (res.body.status) {
            this.$Message.info(res.body.message);
          }
          this.getData();
        });
      }
    },

    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData() {
      api.OutsideProductQueryList(this.parameter).then((res) => {
        this.userList = res.body.data;
        this.userList.list.forEach((element) => {
          element.commission = (element.commission / 100).toFixed(2);
        });
      });
    },
  },
};
</script>

<style scoped>
</style>